import React from "react";
import { ArrowTopRightOnSquareIcon, ArrowPathIcon } from "@heroicons/react/24/outline";

export default function ReadingHistoryTab({ loading, readingHistory, readingTotal }) {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-48">
                <ArrowPathIcon className="h-7 w-7 text-gray-950 animate-spin" />
                <p className="text-xs text-gray-500 mt-2.5 font-bold uppercase tracking-wider">Fetching Reading History...</p>
            </div>
        );
    }

    if (!Array.isArray(readingHistory) || readingHistory.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-48 text-gray-400">
                <p className="text-sm font-semibold uppercase tracking-wider">No Reading History Found</p>
            </div>
        );
    }

    return (
        <div className="space-y-4 w-full">
            <div className="flex items-center justify-between border-b border-gray-150 pb-2">
                <h3 className="text-sm font-semibold text-gray-900 uppercase">
                    Reading History (Total: {readingTotal})
                </h3>
            </div>

            <div className="space-y-4">
                {readingHistory.map((book, idx) => {
                    const productId = book.product_id || "N/A";
                    const bookName = book.name || "Unknown Title";
                    const coverImg = book.image || "https://via.placeholder.com/80x120?text=No+Cover";
                    const credits = book.credits || 0;
                    const lastIssued = book.last_issued_date || "N/A";
                    const lastOrderId = book.last_order_id || "N/A";
                    const permalink = book.permalink || "#";

                    return (
                        <div key={productId + "-" + idx} className="relative flex gap-4 p-4 border border-gray-200 bg-white rounded-lg hover:shadow-md transition-all duration-200 w-full">
                            <img
                                src={coverImg}
                                alt={bookName}
                                className="w-[80px] h-[120px] object-cover rounded border border-gray-100 flex-shrink-0"
                                onError={(e) => {
                                    e.target.src = "https://via.placeholder.com/80x120?text=No+Cover";
                                }}
                            />

                            <div className="flex flex-col justify-between flex-grow min-w-0 pr-10">
                                <div>
                                    <a
                                        href={permalink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="font-semibold text-sm text-gray-955 hover:underline block leading-snug"
                                        title="View Product Page"
                                    >
                                        {bookName}
                                    </a>
                                    <p className="text-[11px] text-gray-400 mt-1">
                                        Product ID: <span className="font-normal text-gray-700">{productId}</span>
                                    </p>
                                </div>

                                <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-xs border-t border-gray-100 pt-3 text-gray-600">
                                    <div className="flex items-center">
                                        <span className="font-medium text-gray-500 mr-1.5">Credits:</span>
                                        <span className="font-bold text-blue-600">{credits}</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="font-medium text-gray-500 mr-1.5">Last Issued:</span>
                                        <span className="font-normal text-gray-800">{lastIssued}</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="font-medium text-gray-500 mr-1.5">Last Order ID:</span>
                                        <span className="font-normal text-gray-800">#{lastOrderId}</span>
                                    </div>
                                </div>
                            </div>

                            <a
                                href={permalink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="absolute top-4 right-4 p-1.5 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center justify-center bg-white shadow-xs transition-colors text-gray-750 hover:text-black hover:border-black"
                                title="Open product permalink in new tab"
                            >
                                <ArrowTopRightOnSquareIcon className="h-4 w-4 stroke-[2]" />
                            </a>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
